// File: `app/javascript/controllers/product_module/transfers.js`
import $ from 'jquery';
import flatpickr from 'flatpickr';
import {withElementBlock} from "../blockUI_controller";

export function initTransfers(deps = {}) {
    const {
        form_type_send,
        create_array_for_product,
        create_id_for_product,
        service_by_dealer,
        get_contract,
        modality_info_by_pick_up_drop_off,
        pick_up_location_info,
        location_make_comment,
        setSessionVar,
        showMapModal,
        showDescriptionModal,
        date_disabled,
        flatpick_lang,
        I18n,
        location,
        sessionStorage
    } = deps;

    if (!form_type_send) return;

    // Selectores
    const transfers_to = $('#transfers_to');
    const transfers_date = $('#transfers_date');
    const transfers_type = $('#transfers_type');
    const transfers_cantidad_block = $('#transfers_cantidad_block');
    const transfers_cantidad = $('#transfers_cantidad');
    const transfers_pul_btn = $('#transfers_pul_btn');
    const transfers_pick_up_location = $('#transfers_pick_up_location');
    const transfers_dol_btn = $('#transfers_dol_btn');
    const transfers_drop_off_location = $('#transfers_drop_off_location');
    const transfers_observaciones = $('#transfers_observaciones');
    const transfers_btn_info = $('#transfers_btn_info');

    // Estado inicial
    transfers_date.prop('disabled', true);
    transfers_cantidad.prop('disabled', true);
    transfers_type.prop('disabled', true).select2({ theme: 'bootstrap' });
    transfers_pick_up_location.prop('disabled', true).select2({
        theme: 'bootstrap',
        placeholder: I18n.t('global.main.form.select_pick_up_location')
    });
    transfers_drop_off_location.prop('disabled', true).select2({
        theme: 'bootstrap',
        placeholder: I18n.t('global.main.form.select_drop_off_location')
    });
    transfers_observaciones.prop('disabled', true);

    // Helper para processResults genérico
    const processRows = (data) => {
        const result = [];
        (data.rows || []).forEach(elem => {
            result.push({ id: `${elem.code}|${elem.id}|${elem.name}`, text: elem.name });
        });
        const total = data.total || 0;
        return {
            results: result,
            pagination: { more: total > 10 && ((parseInt(total) - (10 * parseInt(1))) > 1) }
        };
    };

    // Destinos
    transfers_to.select2({
        theme: "bootstrap",
        placeholder: I18n.t('global.main.form.select_destiny'),
        ajax: {
            url: '/destination',
            dataType: "json",
            language: "es",
            data: function (params) {
                return {
                    form_type: form_type_send.val(),
                    search: params.term,
                    page: params.page || 1
                };
            },
            type: 'GET',
            processResults: function (data, params) {
                params.page = params.page || 1;
                const result = [];
                (data.rows || []).forEach(elem => {
                    result.push({ id: `${elem.code}|${elem.id}|${elem.name}`, text: elem.name });
                });
                const total = data.total || 0;
                return {
                    results: result,
                    pagination: { more: total > 10 && ((parseInt(total) - (10 * parseInt(params.page || 1))) > 1) }
                };
            }
        }
    }).on('change', function (e) {
        transfers_pul_btn[0].classList.add('ocultar');
        transfers_dol_btn[0].classList.add('ocultar');
        transfers_btn_info[0].classList.add('ocultar');

        const parts = (e.target.value || '').split("|");
        const data_transfers_to = parts[1];
        create_array_for_product('product_type', form_type_send.val());
        create_array_for_product('destination_id', parts[1]);
        create_array_for_product('destination_code', parts[0]);
        create_array_for_product('text_destination', parts[2]);

        transfers_type.empty();
        transfers_date.val('');
        transfers_pick_up_location.empty();
        transfers_drop_off_location.empty();

        // FIX (2026-08-10): bloquear el formulario mientras service_by_dealer carga.
        withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
            service_by_dealer(data_transfers_to, form_type_send),
            { timeout: 30000 }
        ).then(sbd => {
            const result = (sbd.services || []).map(elem => ({
                id: `${elem.id}|${elem.code}|${elem.reservation_time}|${sbd.dealer_code}|${sbd.dealer_name}|${sbd.dealer_id}|${elem.min_reservation_amount}|${elem.max_reservation_amount}`,
                text: elem.name
            }));

            // restablecer UI
            transfers_pul_btn[0].classList.add('ocultar');
            transfers_pick_up_location.empty().prop('disabled', false);
            transfers_dol_btn[0].classList.add('ocultar');
            transfers_drop_off_location.empty().prop('disabled', false);
            transfers_observaciones.prop('disabled', true);
            transfers_btn_info[0].classList.add('ocultar');

            if (!result.length) return;

            const product_type = result[0].id.split("|");
            const product_name = (e.target.selectedOptions && e.target.selectedOptions[0] && e.target.selectedOptions[0].innerHTML || '').toLowerCase();

            create_array_for_product('category_id', product_type[0]);
            create_array_for_product('category_code', product_type[1]);
            create_array_for_product('dealer_code', product_type[3]);
            create_array_for_product('dealer_name', product_type[4]);
            create_array_for_product('dealer_id', product_type[5]);

            // FIX (2026-08-10): contrato con bloqueo + desbloqueo garantizado.
            withElementBlock('box-form', I18n.t('global.main.form.message.search_contract'), get_contract('box-form')).then(gcontract => {
                if (!gcontract.next) return;
            });

            // PICK UP LOCATION
            let pick_up_location_name, pick_up_location_latitude, pick_up_location_longitude, pick_up_location_description;
            let drop_off_location_name, drop_off_location_latitude, drop_off_location_longitude, drop_off_location_description;

            transfers_date.prop('disabled', false);

            transfers_pick_up_location.prop('disabled', false).select2({
                theme: "bootstrap",
                placeholder: I18n.t('global.main.form.select_pick_up_location'),
                ajax: {
                    url: `${location.origin}/${sessionStorage.getItem('locale')}/modalities/pick_up_location`,
                    dataType: "json",
                    language: "es",
                    data: function (params) {
                        return { search: params.term, product_type: form_type_send.val() };
                    },
                    type: 'GET',
                    processResults: function (data) {
                        const rows = [];
                        (data.rows || []).forEach(elem => rows.push({ id: elem, text: elem }));
                        return { results: rows };
                    }
                }
            }).off('change').on('change', function (e) {
                const pick_up_location_selected = e.target.value;
                transfers_drop_off_location.empty();
                transfers_observaciones.prop('disabled', false);
                transfers_btn_info[0].classList.add('ocultar');
                location_make_comment(transfers_observaciones, "Punto de Recogida", transfers_pick_up_location, "Punto de Destino", transfers_drop_off_location);

                withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                    pick_up_location_info(pick_up_location_selected),
                    { timeout: 30000 }
                ).then(pick_up_location => {
                    if (pick_up_location.success) {
                        pick_up_location_name = pick_up_location.data.name;
                        pick_up_location_latitude = pick_up_location.data.latitude;
                        pick_up_location_longitude = pick_up_location.data.longitude;
                        pick_up_location_description = pick_up_location.data.description;

                        if (pick_up_location_latitude !== '' && pick_up_location_longitude !== '') {
                            transfers_pul_btn[0].classList.remove('ocultar');
                        } else {
                            transfers_pul_btn[0].classList.add('ocultar');
                        }
                    }
                });
            });

            // DROP OFF LOCATION
            transfers_drop_off_location.prop('disabled', false).select2({
                theme: "bootstrap",
                placeholder: I18n.t('global.main.form.select_drop_off_location'),
                ajax: {
                    url: `${location.origin}/${sessionStorage.getItem('locale')}/modalities/drop_off_location`,
                    dataType: "json",
                    language: "es",
                    data: function (params) {
                        let point_exc = '';
                        if (transfers_pick_up_location[0].selectedOptions.length !== 0) {
                            point_exc = transfers_pick_up_location[0].selectedOptions[0].value;
                        }
                        return { search: params.term, product_type: form_type_send.val(), point_exc: point_exc };
                    },
                    type: 'GET',
                    processResults: function (data) {
                        const rows = [];
                        (data.rows || []).forEach(elem => rows.push({ id: elem, text: elem }));
                        return { results: rows };
                    }
                }
            }).off('change').on('change', function (e) {
                const drop_off_location_selected = e.target.value;
                transfers_observaciones.prop('disabled', false);
                transfers_btn_info[0].classList.add('ocultar');
                location_make_comment(transfers_observaciones, "Punto de Recogida", transfers_pick_up_location, "Punto de Destino", transfers_drop_off_location);

                withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                    pick_up_location_info(drop_off_location_selected),
                    { timeout: 30000 }
                ).then(drop_off_location => {
                    if (drop_off_location.success) {
                        drop_off_location_name = drop_off_location.data.name;
                        drop_off_location_latitude = drop_off_location.data.latitude;
                        drop_off_location_longitude = drop_off_location.data.longitude;
                        drop_off_location_description = drop_off_location.data.description;

                        if (drop_off_location_latitude !== '' && drop_off_location_longitude !== '') {
                            transfers_dol_btn[0].classList.remove('ocultar');
                        } else {
                            transfers_dol_btn[0].classList.add('ocultar');
                        }
                    }
                });

                let point_exc_pick_up = '';
                if (transfers_pick_up_location[0].selectedOptions.length !== 0) {
                    point_exc_pick_up = transfers_pick_up_location[0].selectedOptions[0].value;
                }
                let point_exc_drop_off = '';
                if (transfers_drop_off_location[0].selectedOptions.length !== 0) {
                    point_exc_drop_off = transfers_drop_off_location[0].selectedOptions[0].value;
                }

                withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                    modality_info_by_pick_up_drop_off(form_type_send.val(), point_exc_pick_up, point_exc_drop_off),
                    { timeout: 30000 }
                ).then(modality_by_cant => {
                    if (!modality_by_cant || !modality_by_cant.data || !modality_by_cant.data.length) return;
                    create_array_for_product('modality_code', modality_by_cant.data[0].code);
                    create_id_for_product(product_type[0], product_type[3], product_type[1], modality_by_cant.data[0].code, e.target.value).then();
                    create_array_for_product('modalities_name', modality_by_cant.data[0].name);
                    transfers_cantidad[0].setAttribute('data-min', modality_by_cant.min);
                    transfers_cantidad[0].setAttribute('data-max', modality_by_cant.max);

                    transfers_btn_info[0].classList.remove('ocultar');
                    const transfers_btn_info_desc = modality_by_cant.description;

                    transfers_cantidad.prop('disabled', false).off('change').on('change', function (ev) {
                        create_array_for_product('pax', ev.target.value);
                        create_array_for_product('amount', ev.target.value);
                    });

                    transfers_btn_info.off('click').on('click', function () {
                        showDescriptionModal(`Descripción de ${create_array_for_product('modalities_name', '', 'show')}`, transfers_btn_info_desc);
                    });
                });
            });

            // botones de mapa
            transfers_pul_btn.off('click').on('click', function () {
                showMapModal(pick_up_location_latitude, pick_up_location_longitude, {
                    title: 'Ubicación del punto de recogida',
                    markerText: pick_up_location_name,
                    description: pick_up_location_description
                }).then(() => {});
            });

            transfers_dol_btn.off('click').on('click', function () {
                showMapModal(drop_off_location_latitude, drop_off_location_longitude, {
                    title: 'Ubicación del punto de recogida',
                    markerText: drop_off_location_name,
                    description: drop_off_location_description
                }).then(() => {});
            });

            // calendario
            flatpickr(transfers_date, {
                altInput: true,
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d",
                disable: date_disabled,
                minDate: new Date().fp_incr(parseInt(product_type[2] || 0)),
                maxDate: new Date().fp_incr(90),
                locale: flatpick_lang
            });

            transfers_date.off('change').on('change', function (e) {
                setSessionVar('from_date', e.target.value, 'add', true, false).then(from => {
                    create_array_for_product('from_date', from.value);
                });
                setSessionVar('to_date', e.target.value, 'add', true, false, 1).then(to => {
                    create_array_for_product('to_date', to.value);
                });
            });
        });
    });
}